<template>
  <v-main
    id="supportedBrowsers"
    tabindex="-1"
    style="padding: 0 !important"
    aria-label="Unsupported Browser"
  >
    <v-container fluid class="supported-browsers-content mx-auto mt-4 mt-md-6 mb-4 pb-4">
      <v-card class="mx-auto mb-xs-12 mb-4 pb-4">
        <v-container pb-12 mb-12>
          <v-row class="text-center pt-4 mt-4 mb-4">
            <v-col cols="12">
              <div
                id="unsupported_browser_title"
                class="text-h3 text-md-display-3 text-weight-regular text-center mt-sm-12"
              >
                <span class="font-size--48">
                  {{ $t('L_unsupported_browser_title') }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row class="text-center pb-4 mb-4">
            <v-col cols="12">
              <div id="unsupported_browser_prompt" class="text-h6 text-weight-regular text-center">
                <span>
                  {{ $t('L_unsupported_browser_prompt') }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12" md="4" pb-4>
              <div class="text-h6 text-weight-regular text-center">
                <v-img
                  cover
                  height="200"
                  width="200"
                  alt="Primerica"
                  class="mx-auto mb-2"
                  src="@/assets/browser-chrome.png"
                />
                <p>
                  <a
                    class="text-h6 text-weight-regular"
                    href="https://www.google.com/chrome/"
                    target="_blank"
                    >{{ $t('L_unsupported_browser_google_chrome') }}</a
                  >
                </p>
              </div>
            </v-col>
            <v-col cols="12" md="4" pb-4>
              <div class="text-h6 text-weight-regular text-center">
                <v-img
                  cover
                  height="200"
                  width="200"
                  alt="Primerica"
                  class="mx-auto mb-2"
                  src="@/assets/browser-edge.png"
                />
                <p>
                  <a
                    class="text-h6 text-weight-regular"
                    href="https://www.microsoft.com/en-us/edge"
                    target="_blank"
                    >{{ $t('L_unsupported_browser_microsoft_edge') }}</a
                  >
                </p>
              </div>
            </v-col>
            <v-col cols="12" md="4" pb-4>
              <div class="text-h6 text-weight-regular text-center">
                <v-img
                  cover
                  height="200"
                  width="200"
                  alt="Primerica"
                  class="mx-auto mb-2"
                  src="@/assets/browser-safari.png"
                />
                <p>
                  <a
                    class="text-h6 text-weight-regular"
                    href="https://www.apple.com/safari/"
                    target="_blank"
                    >{{ $t('L_unsupported_browser_apple_safari') }}</a
                  >
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'UnsupportedBrowser',
});
</script>

<style lang="scss" scoped>
.supported-browsers-content {
  max-width: 100% !important;

  @media only screen and (min-width: 760px) {
    max-width: 75% !important;
  }
}

#unsupported_browser_title {
  @media only screen and (max-width: 760px) {
    font-size: 32px !important;
  }
}

#unsupported_browser_prompt {
  @media only screen and (max-width: 760px) {
    font-size: 16px !important;
  }
}

#supportedBrowsers p {
  color: #333 !important;
}

#supportedBrowsers a.text-decoration-none {
  text-decoration: none !important;
}

a.underline-link {
  text-decoration: underline !important;
}

.pad-bottom {
  padding-bottom: 100px;
}
</style>
